export const JIRA_PRODUCT_KEY = 'jiraSoftware';
export const CONFLUENCE_PRODUCT_KEY = 'confluence';
export const STRATEGY_COLLECTION_PRODUCT_KEY = 'strategyCollection';
export const TEAMWORK_COLLECTION_PRODUCT_KEY = 'teamworkCollection';
export const COMPASS_PRODUCT_KEY = 'compass';
export const SERVICE_COLLECTION_PRODUCT_KEY = 'serviceCollection';
export const GUARD_PRODUCT_KEY = 'atlassianGuard';

export const urlSlugToDataProductKey = {
	jira: JIRA_PRODUCT_KEY,
	confluence: CONFLUENCE_PRODUCT_KEY,
	strategy: STRATEGY_COLLECTION_PRODUCT_KEY,
	teamwork: TEAMWORK_COLLECTION_PRODUCT_KEY,
	compass: COMPASS_PRODUCT_KEY,
	service: SERVICE_COLLECTION_PRODUCT_KEY,
	guard: GUARD_PRODUCT_KEY,
};

export type UrlSlug = keyof typeof urlSlugToDataProductKey;
